import { __decorate, __metadata } from "tslib";
import { appendClass, dispatchEvent } from '@1inch-community/core/lit-utils';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import '../../button';
import '../../icon';
import { cardHeaderStyle } from './card-header.style';
let CardHeaderElement = class CardHeaderElement extends LitElement {
    static { this.tahName = 'inch-card-header'; }
    static { this.styles = cardHeaderStyle; }
    constructor() {
        super();
        this.headerTextPosition = 'center';
        this.backButton = false;
        this.closeButton = false;
        this.separator = false;
        this.mini = false;
        this.slotDirty = {};
        this.slot = 'header';
    }
    render() {
        appendClass(this, {
            separator: this.separator,
            mini: this.mini,
        });
        return html `
      <div class="card-header-container">
        <div class="position-container left-container">
          <slot @slotchange="${() => this.onSlotChange('left')}" name="left-container"></slot>
          ${this.getBackButton('left')} ${this.getHeader('left')}
        </div>
        <div class="position-container center-container">
          <slot @slotchange="${() => this.onSlotChange('center')}" name="center-container"></slot>
          ${this.getHeader('center')}
        </div>
        <div class="position-container right-container">
          <slot @slotchange="${() => this.onSlotChange('right')}" name="right-container"></slot>
          ${this.getCloseButton('right')}
        </div>
      </div>
    `;
    }
    firstUpdated() {
        appendClass(this, {
            'not-native-mode': this.parentElement?.localName !== 'inch-card',
        });
    }
    getHeader(containerName) {
        const isSlotDirty = this.slotDirty[containerName] ?? false;
        const classes = {
            'card-header-title': true,
            [`card-header-title__${containerName}`]: true,
            'card-header-title__and-back': this.backButton,
        };
        return this.headerTextPosition === containerName && !isSlotDirty
            ? html ` <span class="${classMap(classes)}">${this.headerText}</span> `
            : '';
    }
    getBackButton(containerName) {
        const isSlotDirty = this.slotDirty[containerName] ?? false;
        return this.backButton && !isSlotDirty
            ? html `
          <inch-button
            @click="${(event) => dispatchEvent(this, 'backCard', null, event)}"
            size="l"
            type="tertiary-gray"
          >
            <inch-icon icon="arrowLeft24"></inch-icon>
          </inch-button>
        `
            : '';
    }
    getCloseButton(containerName) {
        const isSlotDirty = this.slotDirty[containerName] ?? false;
        return this.closeButton && !isSlotDirty
            ? html `
          <inch-button
            @click="${(event) => dispatchEvent(this, 'closeCard', null, event)}"
            size="l"
            type="tertiary-gray"
          >
            <inch-icon icon="cross24"></inch-icon>
          </inch-button>
        `
            : '';
    }
    onSlotChange(slotName) {
        this.slotDirty = { ...this.slotDirty, [slotName]: true };
        this.requestUpdate();
    }
};
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], CardHeaderElement.prototype, "headerText", void 0);
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], CardHeaderElement.prototype, "headerTextPosition", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], CardHeaderElement.prototype, "backButton", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], CardHeaderElement.prototype, "closeButton", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], CardHeaderElement.prototype, "separator", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], CardHeaderElement.prototype, "mini", void 0);
CardHeaderElement = __decorate([
    customElement(CardHeaderElement.tahName),
    __metadata("design:paramtypes", [])
], CardHeaderElement);
export { CardHeaderElement };
//# sourceMappingURL=card-header.element.js.map